import { render } from "./StatusRibbon.vue?vue&type=template&id=328b2390&scoped=true"
import script from "./StatusRibbon.vue?vue&type=script&lang=ts"
export * from "./StatusRibbon.vue?vue&type=script&lang=ts"

import "./StatusRibbon.vue?vue&type=style&index=0&id=328b2390&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-328b2390"

export default script